import { RootState } from "../store";

export const selectFacilityState = (state: RootState) => state.facility;
export const selectFacility = (state: RootState) => state.facility.facility;
export const selectFacilityLoading = (state: RootState) => state.facility.loading;
export const selectFacilityUpdating = (state: RootState) => state.facility.updating;
export const selectFacilityError = (state: RootState) => state.facility.error;
export const selectFacilityUpdateError = (state: RootState) => state.facility.updateError;
